<template>
  <main class="card-pin-manage-page">
    <AppNavBar :title="t('card.pinManageTitle')" background-color="#fff" />

    <section class="pin-manage-content">
      <div class="pin-status-banner">
        <app-image class="pin-status-banner__background" :src="bannerImage" alt="" />
        <app-image class="pin-status-banner__icon" :src="successImage" alt="" />
        <strong>{{ t("card.pinManageSuccess") }}</strong>
      </div>

      <div class="pin-manage-actions">
        <button type="button" class="pin-manage-action" @click="openPinForm('modify')">
          <span class="pin-manage-action__main">
            <app-image :src="editIcon" alt="" />
            <span>{{ t("card.modifyCardPin") }}</span>
          </span>
          <app-image class="pin-manage-action__chevron" :src="chevronIcon" alt="" />
        </button>
        <button type="button" class="pin-manage-action" @click="openPinForm('reset')">
          <span class="pin-manage-action__main">
            <app-image :src="lockIcon" alt="" />
            <span>{{ t("card.resetCardPin") }}</span>
          </span>
          <app-image class="pin-manage-action__chevron" :src="chevronIcon" alt="" />
        </button>
      </div>
    </section>
  </main>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { getRouteState, navigateWithState } from "@/utils/route-state";
import bannerImage from "@/assets/images/cardImage/card-pin-manage-banner.png";
import successImage from "@/assets/images/cardImage/card-pin-set-success.png";
import editIcon from "@/assets/images/cardImage/card-pin-edit.svg";
import lockIcon from "@/assets/images/cardImage/card-pin-lock.svg";
import chevronIcon from "@/assets/images/cardImage/card-pin-chevron.svg";

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const pageState = computed(() => getRouteState(route, "card-pin-manage", {}));

function openPinForm(mode) {
  navigateWithState(router, "/card/pin", {
    namespace: "card-pin",
    payload: {
      cardId: pageState.value.cardId,
      mode,
    },
  });
}
</script>

<style scoped lang="scss">
.card-pin-manage-page {
  min-height: var(--app-viewport-height);
  background: #fff;
}

.pin-manage-content {
  padding: 14px 16px 34px;
}

.pin-status-banner {
  position: relative;
  display: flex;
  height: 81px;
  align-items: center;
  gap: 8px;
  overflow: hidden;
  padding: 0 16px;
  border-radius: 16px;

  &__background {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__icon {
    position: relative;
    width: 49px;
    height: 49px;
    flex: 0 0 49px;
    object-fit: contain;
  }

  strong {
    position: relative;
    color: #2667ff;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
  }
}

.pin-manage-actions {
  margin-top: 20px;
}

.pin-manage-action {
  display: flex;
  width: 100%;
  height: 73px;
  align-items: center;
  justify-content: space-between;
  padding: 0 0 0 2px;
  border: 0;
  border-bottom: 1px solid #f2f2f2;
  background: transparent;
  color: #111;
  text-align: left;

  &__main {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    line-height: 20px;

    .app-image {
      width: 24px;
      height: 24px;
      object-fit: contain;
    }
  }

  &__chevron {
    width: 7.5px;
    height: 13.5px;
    margin-right: 1px;
    object-fit: contain;
  }
}
</style>
